const baseStyleTrack = {
    bg: "greyscale.400",
    borderRadius: "8px",
};
const baseStyleFilledTrack = {
    bg: "primary.500",
};
const baseStyle = {
    filledTrack: baseStyleFilledTrack,
    track: baseStyleTrack,
};
const sizes = {
    sm: {
        track: {
            w: 9,
            h: 1,
        },
    },
};
const defaultProps = {
    size: "sm",
};
const Progress = {
    sizes,
    baseStyle,
    defaultProps,
};
export default Progress;
